"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsUI = void 0;
const button_1 = require("../../../view-components/buttons/button");
const setfunc_1 = require("./setfunc");
class SettingsUI {
    constructor(className) {
        this.settingsHTML = document.createElement('ul');
        this.settingsHTML.classList.add(className);
    }
    static createSettingElement(item) {
        const listItem = document.createElement('li');
        listItem.classList.add('settings-item');
        const insideItem = button_1.ButtonEl.render(`${item}`, `${item}`);
        insideItem.innerText = '';
        const icon = document.createElement('div');
        icon.classList.add('setting-icon');
        insideItem.append(icon);
        listItem.append(insideItem);
        return listItem;
    }
    render() {
        const logout = SettingsUI.createSettingElement('logout');
        const sound = SettingsUI.createSettingElement('sound');
        const music = SettingsUI.createSettingElement('music');
        logout.addEventListener('click', setfunc_1.PopupLogout);
        this.settingsHTML.append(logout);
        this.settingsHTML.append(sound);
        this.settingsHTML.append(music);
        return this.settingsHTML;
    }
}
exports.SettingsUI = SettingsUI;
